import { InferType, object, string } from "yup";
import { Frequency, TFrequency } from "./CreateOrders";

export const NetlinkingBoostSchema = object({
    frequency: string<TFrequency>().required().default(Frequency.EVERY_2_WEEK),
    userKeywords: string().notRequired().default(null),
});

export const UpsertNetlinkingBoostKeywordsSchema = NetlinkingBoostSchema.pick(["frequency"]).concat(
    object({})
);

export const UpsertNetlinkingBoostUserKeywordsSchema = NetlinkingBoostSchema.pick([
    "userKeywords",
]).concat(object({}));

export type NetlinkingBoost = InferType<typeof NetlinkingBoostSchema>;
export type UpsertNetlinkingBoostKeywords = InferType<typeof UpsertNetlinkingBoostKeywordsSchema>;
